import { Zap } from "lucide-react";

const words = ["Gem Mint 10", "Tracked UK shipping", "ACE graded", "Worldwide delivery", "100% positive feedback", "Fresh drops weekly"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {words.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-5xl font-black uppercase tracking-tight sm:text-7xl ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>
        <Zap className="h-8 w-8 fill-volt text-volt" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-white/10 bg-[#0B0D13] py-8" data-testid="editorial-marquee">
    <div className="marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
